<div id="pagination" *ngIf="total > 0">
  <button *ngFor="let pag of pags;" [routerLink]="[currentUrl+'/list/'+pag]" routerLinkActive="active" (click)="sendPag(pag);">{{ pag }}</button>
</div>
